var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 65,
    height: 65,
    rx: 28,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 65,
    height: 65,
    rx: 28,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.167 37C26.167 32.9145 26.167 30.8718 27.4362 29.6025C28.7054 28.3333 30.7482 28.3333 34.8337 28.3333H39.167C43.2525 28.3333 45.2953 28.3333 46.5645 29.6025C47.8337 30.8718 47.8337 32.9145 47.8337 37C47.8337 41.0855 47.8337 43.1283 46.5645 44.3975C45.2953 45.6667 43.2525 45.6667 39.167 45.6667H34.8337C30.7482 45.6667 28.7054 45.6667 27.4362 44.3975C26.167 43.1283 26.167 41.0855 26.167 37Z",
    stroke: "#10B84A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 32.6667L32.8388 34.6157C34.8285 36.2737 35.8233 37.1028 37 37.1028C38.1767 37.1028 39.1715 36.2737 41.1612 34.6157L43.5 32.6667",
    stroke: "#10B84A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLarge);
export default __webpack_public_path__ + "static/media/EmailLarge.1bca46433b3adf31ec11d8533953a0ff.svg";
export { ForwardRef as ReactComponent };